<template>
  <MCVBillingSetList />
</template>

<script>
import MCVBillingSetList from '@/modules/mcvBillingSet/components/billingset-list.vue';

export default {
  name: 'MCVBillingSet',
  components: {
    MCVBillingSetList,
  },
};
</script>
